import axios, { RawAxiosRequestHeaders } from 'axios'

export const getApiClient = (headers?: RawAxiosRequestHeaders) => {
  const baseURL = `${process.env.REACT_APP_API_BASE_URL}`
  return axios.create({
    headers,
    baseURL,
  })
}
